import { render, staticRenderFns } from "./WechatActivityEdit.vue?vue&type=template&id=60e69850&scoped=true&"
import script from "./WechatActivityEdit.vue?vue&type=script&lang=js&"
export * from "./WechatActivityEdit.vue?vue&type=script&lang=js&"
import style0 from "./WechatActivityEdit.vue?vue&type=style&index=0&id=60e69850&lang=scss&scoped=true&"
import style1 from "./WechatActivityEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e69850",
  null
  
)

export default component.exports